import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.RESET = function (state, payload) {
  state.rows = []
}
const state = {
  rows: []
}
const actions = {
  init: ({ commit, state }) => {

  },
  importRows: ({ commit, state }, importRows) => {
    return client.postData({ data: { save: { api: 'S0101DataImportService.importRows', input: importRows } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.save.output)) {
          alert('no match record')
        }
        commit('FIND_ALL', data.save.output)
      })
  },
  readCsv: ({ commit, state }, importCsv) => {
    return client.postData({ data: { csv: { api: 'S0101DataImportService.readCsv', input: importCsv } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.csv.output)) {
          alert('no match record')
        }
        commit('FIND_ALL', data.csv.output)
      })
  },
  reset: ({ commit, state }) => {
    commit('FIND_ALL', [])
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module



// WEBPACK FOOTER //
// ./src/components/functions/S0101DataImport/S0101DataImportStore.js